import {Button} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {FC} from 'react';
import ImageUI from 'ui/ImageUI';

interface IProps {
  title: string;
  onClick: () => void;
}

export const BtnWithPlus: FC<IProps> = ({title, onClick}) => {
  return (
    <Button
      px="30px"
      mt={['15px', '0']}
      variant="outline"
      onClick={onClick}
      _focus={{borderColor: colors.black}}
      _selected={{
        bg: colors.white,
        border: 'none',
      }}
      leftIcon={<ImageUI w="1rem" h="1rem" src="/icons/plus.svg" alt="Plus" />}
    >
      {title}
    </Button>
  );
};
